import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { compose, withProps } from 'recompose'
import React, { Fragment, useState } from 'react'
import { useLocale } from '../Locale/useLocale'

const MAP_STYLES = [
    {
        featureType: 'administrative.land_parcel',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'administrative.neighborhood',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.business',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'transit',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
]

const RGMap = compose(
    withProps({
        loadingElement: <div style={{ height: `100%` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withScriptjs,
    withGoogleMap
)((props) => {
    const [windowStates, windowStates_set] = useState<{ [id: number]: boolean }>({})
    const { lang } = useLocale<Locale.Keys>()
    return (
        <GoogleMap
            defaultZoom={13}
            defaultCenter={(props as any).defaultCenter}
            options={{ styles: MAP_STYLES as any, mapTypeId: 'satellite' }}
            onClick={(props as any).onClick}
        >
            {(props as any).markers &&
                (props as any).markers.map((marker: any, index: number) => (
                    <Fragment key={index}>
                        <Marker
                            position={marker.position}
                            {...marker.otherProps}
                            onClick={() =>
                                windowStates_set((current) => {
                                    return { [index]: true }
                                })
                            }
                        ></Marker>
                        {windowStates[index] && (
                            <InfoWindow
                                position={marker.position}
                                onCloseClick={() =>
                                    windowStates_set((current) => {
                                        return { [index]: false }
                                    })
                                }
                            >
                                <div className="mapInfoWindow">
                                    <h1>{marker.info?.title}</h1>
                                    <p>
                                        <span>{lang.pages.reportsMap.dateReported}:</span>
                                        <span>{marker.info?.date}</span>
                                    </p>
                                    <p>
                                        <span>{lang.pages.reportsMap.reportedBy}:</span>
                                        <span>{marker.info?.reportedBy}</span>
                                    </p>
                                    <p>
                                        <span>Email:</span>
                                        <span>{marker.info?.email || 'n/a'}</span>
                                    </p>
                                </div>
                            </InfoWindow>
                        )}
                    </Fragment>
                ))}
        </GoogleMap>
    )
})

export default (RGMap as unknown) as (props: {
    defaultCenter: { lat: number; lng: number }
    onClick?: (e: any) => void
    markers?: { position: { lat: number; lng: number }; otherProps?: any }[]
    googleMapURL: string
    containerElement: JSX.Element
}) => JSX.Element
